import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref } from 'vue';
import { useGetCsrdIntroQuery, useUpdateAccountMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Intro',
  setup: function setup(__props) {
    var _useGetCsrdIntroQuery = useGetCsrdIntroQuery(),
      result = _useGetCsrdIntroQuery.result,
      loading = _useGetCsrdIntroQuery.loading;
    var showCsrdIntro = computed(function () {
      var _result$value, _result$value$getAcco;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getAcco = _result$value.getAccount) === null || _result$value$getAcco === void 0 ? void 0 : _result$value$getAcco.showCsrdIntro;
    });
    var _useUpdateAccountMuta = useUpdateAccountMutation(),
      updateAccount = _useUpdateAccountMuta.mutate;
    var showIntroStepper = ref(false);
    onMounted(function () {
      showIntroStepper.value = true;
    });
    var closeDialog = function closeDialog() {
      showIntroStepper.value = false;
    };
    var toggleShowCsrd = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return updateAccount({
                input: {
                  showCsrdIntro: false
                }
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function toggleShowCsrd() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      result: result,
      loading: loading,
      showCsrdIntro: showCsrdIntro,
      updateAccount: updateAccount,
      showIntroStepper: showIntroStepper,
      closeDialog: closeDialog,
      toggleShowCsrd: toggleShowCsrd
    };
  }
});